<div class="card">
  <div class="card-header">Social Networks</div>
  <div class="card-body">
    <app-linkedin-badge></app-linkedin-badge>
  </div>
</div>
